import { render, staticRenderFns } from "./toDaySupplyChain.vue?vue&type=template&id=2044b4aa&scoped=true"
import script from "./toDaySupplyChain.vue?vue&type=script&lang=js"
export * from "./toDaySupplyChain.vue?vue&type=script&lang=js"
import style0 from "./toDaySupplyChain.vue?vue&type=style&index=0&id=2044b4aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2044b4aa",
  null
  
)

export default component.exports